class SourceUpdatesAttributeBreakdownRow {
    constructor(
        public attributeName: string = "",
        public itemCount: number = 0,
        public changeCount: number = 0,
        public recentItemCount: number = 0
    ) {
    }

    public static fromPOJO(data: any) {
        return new SourceUpdatesAttributeBreakdownRow(
            data?.attributeName ?? "",
            data?.itemCount ?? 0,
            data?.changeCount ?? 0,
            data?.recentItemCount ?? 0
        );
    }
}

export default SourceUpdatesAttributeBreakdownRow;
